import { chakra, ChakraComponent } from "@chakra-ui/react";
import React from "react";

//Icons
import { ReactComponent as CloseSvg } from "../assets/icons/close-sm.svg";
import { ReactComponent as BackSvg } from "../assets/icons/arrow-back.svg";
import { ReactComponent as PlaySvg } from "../assets/icons/play.svg";
import { ReactComponent as WallpaperSvg } from "../assets/icons/wallpaper.svg";
import { ReactComponent as CheckmarkSvg } from "../assets/icons/checkmark-sm.svg";
import { ReactComponent as CrossSvg } from "../assets/icons/close-xs.svg";
import { ReactComponent as PlusSvg } from "../assets/icons/plus-xs.svg";
import { ReactComponent as PlaySoundSvg } from "../assets/icons/play-sound.svg";


//Illustrations
import { ReactComponent as FloSplashInlinedSvg } from "../assets/illustrations/splash-illustration.svg";
import { ReactComponent as FloSplashSvg } from "../assets/illustrations/splash-flo.svg";
import { ReactComponent as AppleSvg } from "../assets/images/category/food.svg";
import { ReactComponent as ScienceSvg } from "../assets/images/category/logical.svg";
import { ReactComponent as AutresSvg } from "../assets/images/category/autres.svg";
import { ReactComponent as PenSvg } from "../assets/illustrations/pen.svg";
import { ReactComponent as FloSvg } from "../assets/illustrations/flo.svg";
import { ReactComponent as AlloprofLogoSvg } from "../assets/images/logo.svg";
import { ReactComponent as UnsureTeenSvg } from "../assets/images/flos/unsure_teen.svg"
import { ReactComponent as FloIdleSvg } from "../assets/images/idle.svg";
import { ReactComponent as SuccessSvg } from "../assets/illustrations/exercise-success.svg";
import { ReactComponent as ErrorSvg } from "../assets/illustrations/exercise-error.svg";

export type SvgProps = React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string | undefined }>

export const Close: ChakraComponent<SvgProps> = chakra(CloseSvg)
export const Back: ChakraComponent<SvgProps> = chakra(BackSvg)
export const Play: ChakraComponent<SvgProps> = chakra(PlaySvg)
export const Cross: ChakraComponent<SvgProps> = chakra(CrossSvg);
export const Plus: ChakraComponent<SvgProps> = chakra(PlusSvg);
export const Wallpaper: ChakraComponent<SvgProps> = chakra(WallpaperSvg)
export const Checkmark: ChakraComponent<SvgProps> = chakra(CheckmarkSvg);
export const PlaySound: ChakraComponent<SvgProps> = chakra(PlaySoundSvg);

export const Apple: ChakraComponent<SvgProps> = chakra(AppleSvg)
export const Science: ChakraComponent<SvgProps> = chakra(ScienceSvg)
export const Autres: ChakraComponent<SvgProps> = chakra(AutresSvg)
export const Flo: ChakraComponent<SvgProps> = chakra(FloSvg)
export const Pen: ChakraComponent<SvgProps> = chakra(PenSvg)
export const AlloprofLogo: ChakraComponent<SvgProps> = chakra(AlloprofLogoSvg)
export const FloSplash: ChakraComponent<SvgProps> = chakra(FloSplashSvg)
export const FloIdle: ChakraComponent<SvgProps> = chakra(FloIdleSvg)
export const UnsureTeen: ChakraComponent<SvgProps> = chakra(UnsureTeenSvg);
export const Success: ChakraComponent<SvgProps> = chakra(SuccessSvg)
export const Error: ChakraComponent<SvgProps> = chakra(ErrorSvg);
export const FloSplashInlined: ChakraComponent<SvgProps> = chakra(FloSplashInlinedSvg);

